var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".56em",
    height: "1em",
    viewBox: "0 0 13.503 23.619"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18752"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.07 11.806 8.937-8.93A1.688 1.688 0 0 0 10.616.492L.491 10.606a1.685 1.685 0 0 0-.049 2.327l10.167 10.193A1.688 1.688 0 0 0 13 20.742Z",
    "data-name": "Icon ionic-ios-arrow-back"
  }))));
};
export default SvgBack;